import type {
  MdtEvidenceEventDetail,
  MdtGpsEventDetail,
  MdtInboundMessage,
} from "@hydeck/mdt-contracts";
import { authenticateWithToken } from "./session";

let cleanup: (() => void) | null = null;

export function installMdtBridge() {
  cleanup?.();

  const listener = (event: MessageEvent<Partial<MdtInboundMessage>>) => {
    if (event.data?.resource !== "mdt" || !event.data.type) {
      return;
    }

    if (
      (event.data.type === "mdt:switch" || event.data.type === "mdt:open") &&
      "accessToken" in event.data &&
      event.data.accessToken
    ) {
      localStorage.removeItem("user");
      void authenticateWithToken(event.data.accessToken);
    }

    if (
      event.data.type === "mdt:hideWarrants" &&
      "value" in event.data
    ) {
      localStorage.setItem("hide-warrants", String(event.data.value));
      document.body.dispatchEvent(new Event("warrantsModeChange"));
    }
  };

  window.addEventListener("message", listener);
  cleanup = () => window.removeEventListener("message", listener);
  return cleanup;
}

export function setGps(detail: MdtGpsEventDetail) {
  window.parent.dispatchEvent(new CustomEvent("mdt:setGps", { detail }));
}

export function enterEvidence(detail: MdtEvidenceEventDetail) {
  window.parent.dispatchEvent(new CustomEvent("mdt:enterEvidence", { detail }));
}
